export const minWidth = {
  sm: `@media (min-width: 375px)`,
  md: '@media (min-width: 768px)',
  lg: '@media (min-width: 976px)',
}